<template>
  <router-link :to="{ name: 'Order' }" class="smartphone-floating-basket" v-if="showBasket">
    <div class="icon"><svg-inline :src="require('@/assets/icons/cart.svg')" /></div>
    <div class="label">Корзина</div>
    <div class="total">{{ totalSum | money }} <rub /></div>
    <div class="crossed-total" v-if="totalSumBeforeDiscount !== totalSum">{{ totalSumBeforeDiscount | money }} <rub /></div>
    <div class="ver-line"></div>
    <div class="lines">{{ totalItems }}</div>
  </router-link>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SmartphoneFloatingBasket',
    data () {
      return {
        // expanded: true
      }
    },
    computed: {
      ...mapGetters({
        totalSum: 'cart/totalSum',
        totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
        totalItems: 'cart/totalItems'
      }),
      showBasket () {
        return this.totalItems > 0 && this.$route.name !== 'Order'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SmartphoneFloatingBasket.vue